import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Input, Row, Col, Select, Spin, Space } from 'antd';
import { get, save, setPending } from '../redux/actions/sociedadActions';
import cloneDeep from 'lodash/cloneDeep';
import {
  ExclamationCircleOutlined,
  DeleteFilled,
  EditFilled,
  PlusOutlined,
} from '@ant-design/icons';
import { compareObject } from '../utils/funtions';
import { callStatus } from '../utils/constants';
import { Notificacion } from './Notificacion';
import MetaTable from './base/MetaTable';
import InversorEditor from './InversorEditor';
import { setPending as setPendingInversor } from '../redux/actions/inversorActions';

import {
  DraggableModal,
  DraggableModalProvider,
} from 'ant-design-draggable-modal';

const { Option } = Select;

const { confirm } = Modal;

const SociedadEditor = ({
  dispatch,
  id,
  stateData,
  visible,
  onCancel,
  inversor,
}) => {
  const [form] = Form.useForm();

  const [showEditInversor, setShowEditInversor] = useState(false);
  const [inversorId, setInversorId] = useState(null);

  const handleEditInversor = (id) => {
    setInversorId(id);
    setShowEditInversor(true);
  };

  const handleHideEditorInversor = () => {
    setShowEditInversor(false);
    setInversorId(null);
    dispatch(setPendingInversor());
  };

  useEffect(() => {
    if (id) {
      if (String(stateData.object.data?.id) !== String(id)) {
        dispatch(get(id));
      }
    } else {
      dispatch(setPending());
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      inversor.object.status === callStatus.OBJECT_SAVE_SUCCESS &&
      showEditInversor
    ) {
      const savedInversor = inversor.object.data;
      if (!inversorId) {
        setInversores((prev) => {
          if (!prev.some((p) => p.inversor_id === savedInversor.id)) {
            return [
              ...prev,
              {
                inversor_id: savedInversor.id,
                inversor_nombre: savedInversor.nombre,
                ganancia: 0,
              },
            ];
          }
          return prev;
        });
      } else {
        setInversores((prev) =>
          prev.map((p) =>
            p.inversor_id === savedInversor.id
              ? { ...p, inversor_nombre: savedInversor.nombre }
              : p
          )
        );
      }
    }
  }, [
    inversor.object.status,
    showEditInversor,
    inversorId,
    inversor.object.data,
  ]);

  useEffect(() => {
    let data = cloneDeep(stateData.object.data);

    if (stateData.object.status === callStatus.OBJECT_SUCCESS) {
      if (stateData.object.data.inversores) {
        setInversores(stateData.object.data.inversores);
      }
    } else if (stateData.object.status === callStatus.OBJECT_PENDING) {
      form.resetFields();
      setInitial({});
      setInversores([]);
    } else if (stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS) {
      Notificacion('El registro se guardó con éxito', 'success', onCancel);
    } else if (stateData.object.status === callStatus.OBJECT_FAILED) {
      Notificacion(stateData.object.error, 'error', () => {});
    }
    form.setFieldsValue(data);
    setInitial(data);
    // eslint-disable-next-line
  }, [stateData.object]);

  const onCreate = (data) => {
    dispatch(save(data));
  };

  const [initial, setInitial] = useState({});

  const handleOnCancel = () => {
    if (compareObject(initial, form.getFieldsValue())) {
      confirm({
        title: '¿Posee cambios sin guardar, desea continuar?',
        icon: <ExclamationCircleOutlined />,
        okText: 'Si',
        cancelText: 'No',
        autoFocusButton: 'cancel',
        onOk() {
          onCancel();
        },
        onCancel() {},
      });
    } else {
      onCancel();
    }
  };

  const handleDelete = (data) => {
    setInversores((prev) =>
      prev.filter((item) => item.inversor_id !== data.inversor_id)
    );
  };

  const handleConfirmDelete = (item) => {
    confirm({
      title: '¿Está a punto de quitar un aportante, desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete(item);
      },
      onCancel() {},
    });
  };

  const onGananciaInversorChange = (e, key, index, record) => {
    let newData = [...inversores];
    newData = [
      ...newData.map((item) => {
        if (item.inversor_id === record.inversor_id) {
          return { ...item, ganancia: e.target.value };
        } else {
          return item;
        }
      }),
    ];
    setInversores(newData);
  };

  const [inversores, setInversores] = useState([]);
  const columnsInversor = [
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <EditFilled onClick={() => handleEditInversor(record.inversor_id)} />
          <DeleteFilled onClick={() => handleConfirmDelete(record)} />
        </Space>
      ),
      width: 60,
    },
    {
      ellipsis: true,
      title: 'Nombre',
      dataIndex: 'inversor_nombre',
    },
    {
      width: 150,
      title: 'Ganancia %',
      dataIndex: 'ganancia',
      render: (text, record, index) => (
        <Input
          type="number"
          value={text}
          onChange={(e) =>
            onGananciaInversorChange(e, 'ganancia', index, record)
          }
        />
      ),
    },
  ];

  const [inversorData, setInversorData] = useState([]);

  useEffect(() => {
    setInversorData(inversor.list.data);
    // eslint-disable-next-line
  }, [inversor]);

  const [resultSearchInversor, setResultSearchInversor] = useState([]);

  const onSearchInversor = (value) => {
    const result = inversorData.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase())
    );
    setResultSearchInversor(result);
  };

  const onChangeInversor = (value) => {
    const result = inversorData.find((item) => item.id === value);

    setInversores([
      ...inversores,
      { inversor_id: result.id, inversor_nombre: result.nombre, ganancia: 0 },
    ]);

    setResultSearchInversor([]);
    form.setFieldsValue({
      search_inversor_id: null,
    });
  };

  useEffect(() => {
    form.setFieldsValue({
      inversores: inversores,
    });
    // eslint-disable-next-line
  }, [inversores]);

  return (
    <>
      <DraggableModalProvider>
        <DraggableModal
          mask
          initialWidth={600}
          initialHeight={500}
          maskClosable={false}
          visible={visible}
          title={
            stateData.object.data.id ? 'Editar Sociedad' : 'Nueva Sociedad'
          }
          okText="Guardar"
          cancelText="Salir"
          onCancel={handleOnCancel}
          onOk={() => {
            form
              .validateFields()
              .then((values) => {
                onCreate(values);
              })
              .catch((info) => {
                console.log('Validate Failed:', info);
              });
          }}
        >
          <Spin
            spinning={
              stateData.object.status === callStatus.OBJECT_IN_PROCESS ||
              !!(id && stateData.object.status === callStatus.OBJECT_PENDING)
            }
          >
            <Form form={form} layout="vertical" name="form_in_modal">
              <Row gutter={[8, 0]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item name="id" label="id" style={{ display: 'none' }}>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[8, 0]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item
                    name="nombre"
                    label="Nombre"
                    rules={[{ required: true, message: 'Requerido' }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[8, 0]} align="middle">
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Form.Item
                      label="Aportantes"
                      name="search_inversor_id"
                      style={{
                        flex: 1,
                      }}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={onSearchInversor}
                        onChange={onChangeInversor}
                        notFoundContent={null}
                        allowClear
                        placeholder="Buscar Aportante"
                      >
                        {resultSearchInversor.map((item, index) => (
                          <Option key={index} value={item.id}>
                            {item.nombre}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <div style={{ marginTop: '5px' }}>
                      <PlusOutlined
                        onClick={() => {
                          setInversorId(null);
                          setShowEditInversor(true);
                        }}
                        style={{ paddingLeft: '7px', cursor: 'pointer' }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Form.List
                  name="inversores"
                  rules={[
                    {
                      validator: async (_, inversores) => {
                        if (!inversores || inversores.length < 1) {
                          return Promise.reject(
                            new Error('Seleccione al menos un aportante')
                          );
                        }
                      },
                    },
                  ]}
                >
                  {(fields, { add, remove }, { errors }) => (
                    <>
                      {errors.length > 0 && (
                        <Row
                          gutter={[0, 0]}
                          style={{ width: '100%' }}
                          align="top"
                          justify="center"
                        >
                          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Form.Item>
                              <Form.ErrorList errors={errors} />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                    </>
                  )}
                </Form.List>
                {inversores && inversores.length > 0 && (
                  <MetaTable
                    dataSource={inversores}
                    dataColumns={columnsInversor}
                    bordered={false}
                    selection={false}
                    cssStyle={true}
                  />
                )}
              </Row>
            </Form>
          </Spin>
        </DraggableModal>
        {showEditInversor ? (
          <InversorEditor
            id={inversorId}
            onCancel={handleHideEditorInversor}
            visible={true}
          />
        ) : (
          false
        )}
      </DraggableModalProvider>
    </>
  );
};

const mapStateToProps = (state) => {
  const { sociedad, inversor } = state;
  const stateData = sociedad;
  return {
    stateData,
    inversor,
  };
};
export default connect(mapStateToProps)(SociedadEditor);
